import React, {
    useRef,
    useEffect,
    useState
  } from 'react';
  import PropTypes from 'prop-types';
  import { withStyles } from '@material-ui/core/styles';
  import classNames from 'classnames';
  import styles from './sidebar-jss';
  import {DataMenu} from './Menu';
  import MainMenu from './ZMainMenu';
  
  function SidebarContent(props) {
    const {
      classes,
      drawerPaper,
      toggleDrawerOpen,
      leftSidebar,
    } = props;
    const refSidebar = useRef(null);
  
    return (
      <div className={classNames(classes.drawerInner, !drawerPaper ? classes.drawerPaperClose : '')}>
        <div
          ref={refSidebar}
          className={
            classNames(
              classes.menuContainer,
              leftSidebar && classes.rounded,
              classes.withProfile
            )
          }
        >
          <MainMenu dataMenu={DataMenu} toggleDrawerOpen={toggleDrawerOpen} />
        </div>
      </div>
    );
  }
  
  
  SidebarContent.defaultProps = {
    toggleDrawerOpen: () => { },
    toggleDrawerClose: () => { },
    anchorEl: null,
  };
  
  export default withStyles(styles)(SidebarContent);
  